import * as React from "react";
import { useState, useRef, useEffect } from "react";
import clx from "clsx";
import Box from "../box";
import { store } from "../../models/store";
import { avatarBadge, avatarBadgePlacement } from "../avatar/avatar.css";
import type { AvatarBadgeProps } from "../avatar/avatar.types";

function AvatarBadge(props: AvatarBadgeProps) {
  const cleanupRef = useRef<() => void>(null);
  const [theme, setTheme] = useState(() => "light");

  useEffect(() => {
    setTheme(store.getState().theme);
    cleanupRef.current = store.subscribe((newState, prevState) => {
      setTheme(newState.theme);
    });
  }, []);

  useEffect(() => {
    return () => {
      if (typeof cleanupRef.current === "function") cleanupRef.current();
    };
  }, []);

  return (
    <Box
      display="flex"
      position="absolute"
      alignItems="center"
      justifyContent="center"
      borderRadius="$full"
      boxRef={props.boxRef}
      borderWidth={props.borderWidth}
      {...props.attributes}
      width={props.size}
      height={props.size}
      className={clx(
        avatarBadge[theme],
        avatarBadgePlacement[props.placement],
        props.className
      )}
    >
      {props.children}
    </Box>
  );
}

AvatarBadge.defaultProps = {
  placement: "bottom-right",
  size: "1.25em",
  borderWidth: "0.2em",
};

export default AvatarBadge;
